import React from 'react';
import {useDispatch} from 'react-redux';
import {compose} from 'redux';

import styles from './ModalLink.module.scss';

import {
  openModal as openModalAction
} from '../../../../redux/modules/modals/modals.module';

const ModalLink = (
  { className, link, linkStyle = 'none', modalName, openModal, modalProps } // eslint-disable-next-line
) => {
  const dispatch = useDispatch();
  return (
    <button
      aria-label='modal-link'
      id={`modal-link-${modalName}`}
      onClick={() => dispatch(openModalAction(modalName, modalProps))}
      className={`${styles['modal-link']} ${styles[linkStyle]} ${
        styles[className] ? styles[className] : ''
      }`}
    >
      {link}
    </button>
  );
};

export default compose(ModalLink);
